import { useLogin } from './reducer/useLogin';
import {
  Routes,
  METRICS_LOGIN_METHOD,
  METRICS_LOGIN_METHOD_SMS,
  METRICS_SUCCESS_LOGIN,
  useAnalytics,
} from '@xolv-mybrightlink/common';
import { PhoneNumberInputForm } from './PhoneNumberInputForm';
import { LoginOtpInputForm } from './LoginOtpInputForm';
import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

export const LoginPage = () => {
  const navigate = useNavigate();
  const state = useLogin();
  const analytics = useAnalytics();
  const stateData = state.data;
  const loginStep = state.data.type;

  useEffect(() => {
    if (
      stateData.type === 'REQUESTING_OTP' &&
      stateData.error === 'local-user-not-found'
    ) {
      navigate(Routes.register, {
        state: { phoneNumber: stateData.phoneNumber },
      });
    }
  }, [navigate, stateData]);

  useEffect(() => {
    if (loginStep == 'VERIFYING_OTP_SUCCESS') {
      analytics.trackAction(METRICS_SUCCESS_LOGIN, {
        [METRICS_LOGIN_METHOD]: METRICS_LOGIN_METHOD_SMS,
      });
    }
  }, [analytics, loginStep]);

  if (loginStep === 'REQUESTING_OTP') {
    return <PhoneNumberInputForm />;
  } else if (loginStep === 'VERIFYING_OTP') {
    return <LoginOtpInputForm />;
  } else if (loginStep === 'VERIFYING_OTP_SUCCESS') {
    return <Navigate to={Routes.authenticated} />;
  } else {
    throw new Error('Unknown login step ' + loginStep);
  }
};
